var Account, AccountSwitcherViewModel;

Account = (function() {
  function Account(options) {
    var i, idx, ref;
    this.rawAcct = options.rawAcct;
    this.alias = this.rawAcct.accountAlias;
    this.name = ko.asObservable(this.rawAcct.businessName);
    this.primaryDatacenter = ko.asObservable(this.rawAcct.primaryDataCenter);
    this.path = options.path;
    this.depth = options.depth;
    this.depthHtml = '';
    for (idx = i = 0, ref = this.depth; 0 <= ref ? i <= ref : i >= ref; idx = 0 <= ref ? ++i : --i) {
      if (idx > 0) {
        this.depthHtml = this.depthHtml + "<span class='marker'>&mdash;</span>";
      }
    }
    this.pathDisplayText = ko.pureComputed((function(_this) {
      return function() {
        return _this.path + " - " + (_this.name());
      };
    })(this));
  }

  return Account;

})();

AccountSwitcherViewModel = (function() {
  function AccountSwitcherViewModel(options) {
    var _activeItemIndex, _calcWeight, _close, _createAccountModel, _setCurrentAccount, _sortByWeight, pageSize;
    options = options || {};
    this.isOpen = ko.observable(false);
    this.isOpen.subscribe((function(_this) {
      return function(newValue) {
        if (newValue) {
          return $("account-switcher .take-over").animate({
            top: 40,
            bottom: 0
          });
        } else {
          return $("account-switcher .take-over").animate({
            top: '-100%',
            bottom: '100%'
          });
        }
      };
    })(this));
    this.toggleHandler = (function(_this) {
      return function(data, event) {
        $('body').toggleClass('account-switcher-open');
        _this.isOpen(!_this.isOpen());
        if (_this.isOpen()) {
          if (!_this.loading()) {
            $('account-switcher .take-over .search-input input').focus();
          }
          return $('account-switcher .toggle-btn svg').animate({
            deg: 180
          }, {
            step: function(now, fx) {
              $(this).css('-webkit-transform', 'rotate(' + now + 'deg)');
              $(this).css('-moz-transform', 'rotate(' + now + 'deg)');
              return $(this).css('transform', 'rotate(' + now + 'deg)');
            },
            duration: 250
          }, 250);
        } else {
          $('account-switcher .toggle-btn svg').animate({
            deg: 0
          }, {
            step: function(now, fx) {
              $(this).css('-webkit-transform', 'rotate(' + now + 'deg)');
              $(this).css('-moz-transform', 'rotate(' + now + 'deg)');
              return $(this).css('transform', 'rotate(' + now + 'deg)');
            },
            duration: 250
          }, 250);
          _this.clearSearch();
          _this.forceShowAllAccts(false);
          return _activeItemIndex(-1);
        }
      };
    })(this);
    _close = (function(_this) {
      return function() {
        $('body').removeClass('account-switcher-open');
        _this.isOpen(false);
        _this.clearSearch();
        _this.forceShowAllAccts(false);
        return _activeItemIndex(-1);
      };
    })(this);
    this.clearSearch = (function(_this) {
      return function() {
        var _activeItemIndex;
        _this.flatOrgList.query('');
        _activeItemIndex = -1;
        return _this.flatOrgList.clearSort();
      };
    })(this);
    this.currentAccountAlias = ko.asObservable(options.currentAccountAlias);
    this.loading = ko.asObservable(options.loading);
    this.rawAccounts = ko.asObservableArray(options.accounts || []);
    this.flatOrgList = ko.filterableArray([], {
      fields: ['alias', 'name'],
      comperer: function(query, acct) {
        if (acct.alias.indexOf(query.toLowerCase()) === 0) {
          return true;
        }
        if (acct.businessName.toLowerCase().indexOf(query.toLowerCase()) > -1) {
          return true;
        }
        return false;
      }
    });
    this.flatOrgList.query.subscribe((function(_this) {
      return function() {
        _this.forceShowAllAccts(false);
        return _activeItemIndex(0);
      };
    })(this), null, 'beforeChange');
    this.isSearching = ko.computed((function(_this) {
      return function() {
        return !!_this.flatOrgList.query();
      };
    })(this));
    _createAccountModel = (function(_this) {
      return function(options) {
        var depth, path;
        path = options.path + " / " + options.rawAcct.accountAlias;
        depth = options.depth++;
        options.accounts.push(new Account({
          rawAcct: options.rawAcct,
          path: path,
          depth: depth
        }));
        return options.rawAcct.subAccounts.forEach(function(acct) {
          return _createAccountModel({
            rawAcct: acct,
            path: path,
            depth: depth + 1,
            accounts: options.accounts
          });
        });
      };
    })(this);
    ko.computed((function(_this) {
      return function() {
        var accounts;
        accounts = [];
        _this.rawAccounts().forEach(function(acct) {
          return _createAccountModel({
            rawAcct: acct,
            path: '',
            depth: 0,
            accounts: accounts
          });
        });
        _this.flatOrgList(accounts);
      };
    })(this));
    this.getImpersonatedOrgDiaplayText = (function(_this) {
      return function(acct) {
        return (acct.alias.toUpperCase()) + " - " + (ko.unwrap(acct.name));
      };
    })(this);
    this.impersonatedOrg = ko.observable();
    this.impersonatedOrg.subscribe((function(_this) {
      return function(newValue) {
        return _this.currentAccountAlias(newValue.alias);
      };
    })(this));
    _setCurrentAccount = (function(_this) {
      return function() {
        var possibleAccounts;
        possibleAccounts = _this.flatOrgList().filter(function(acct) {
          return acct.alias.toLowerCase() === _this.currentAccountAlias().toLowerCase();
        });
        if (possibleAccounts.length === 1) {
          return _this.impersonatedOrg(possibleAccounts[0]);
        } else {
          throw 'There is more than one account with the same alias, this should not be possible check the data please.';
        }
      };
    })(this);
    if (!this.loading()) {
      _setCurrentAccount();
    } else {
      this.loading.subscribe((function(_this) {
        return function(newValue) {
          if (!newValue) {
            return _setCurrentAccount();
          }
        };
      })(this));
    }
    this.impersonateOrg = (function(_this) {
      return function(acct) {
        _this.impersonatedOrg(acct);
        return _this.toggleHandler();
      };
    })(this);
    pageSize = 50;
    this.forceShowAllAccts = ko.observable(false);
    this.showAllOrgsHandler = (function(_this) {
      return function() {
        return _this.forceShowAllAccts(true);
      };
    })(this);
    this.showingAllOrgs = ko.pureComputed((function(_this) {
      return function() {
        var total, visible;
        total = _this.flatOrgList().length;
        visible = _this.displayOrgs().length;
        return visible === total;
      };
    })(this));
    this.limitedOrgsDisplayedMessage = ko.pureComputed((function(_this) {
      return function() {
        var total, visible;
        total = _this.flatOrgList().length;
        visible = _this.displayOrgs().length;
        if (_this.loading()) {
          return '';
        } else if (_this.forceShowAllAccts() || visible === total) {
          return total + " accounts";
        } else {
          return "Showing " + visible + " of " + total + " accounts";
        }
      };
    })(this));
    _sortByWeight = (function(_this) {
      return function(a, b) {
        var aVal, bVal, query;
        query = _this.flatOrgList.query();
        aVal = _calcWeight(a, query);
        bVal = _calcWeight(b, query);
        if (aVal > bVal) {
          return -1;
        } else if (aVal < bVal) {
          return 1;
        } else {
          if (_this.flatOrgList.all().indexOf(a) < _this.flatOrgList.all().indexOf(b)) {
            return -1;
          } else {
            return 1;
          }
        }
      };
    })(this);
    _calcWeight = function(acct, query) {
      var alias, idx, result;
      result = 0;
      if (!!query) {
        query = query.toLowerCase();
        alias = acct.alias.toLowerCase();
        if (alias === query) {
          result += 100;
        } else if (alias.indexOf(query) === 0) {
          result += 30;
        }
        idx = acct.rawAcct.businessName.toLowerCase().indexOf(query);
        if (idx === 0) {
          result += 20;
        } else if (idx > -1) {
          result += 10;
        }
      }
      return result;
    };
    this.displayOrgs = ko.pureComputed((function(_this) {
      return function() {
        var end, result, start;
        result = _this.flatOrgList();
        if (!_this.forceShowAllAccts()) {
          end = 1 * pageSize;
          start = end - pageSize;
          result = _this.flatOrgList().slice(start, end);
        }
        return helpers.stableMergeSort(result, _sortByWeight);
      };
    })(this));
    _activeItemIndex = ko.observable(-1);
    this.activeItem = ko.pureComputed((function(_this) {
      return function() {
        var value;
        value = _activeItemIndex();
        if (value > -1) {
          return _this.displayOrgs()[value];
        }
      };
    })(this));
    this.hoverHandler = (function(_this) {
      return function(data, event) {
        return _activeItemIndex(_this.displayOrgs().indexOf(data));
      };
    })(this);
    this.isActiveItem = (function(_this) {
      return function(data) {
        return data === _this.activeItem();
      };
    })(this);
    this.isCurrentItem = (function(_this) {
      return function(data) {
        return data === _this.impersonatedOrg();
      };
    })(this);
    this.forceShowAllAccts.subscribe(function() {
      return _activeItemIndex(0);
    });
    $(document).on('keydown', (function(_this) {
      return function(e) {
        var activeAccount;
        if (e.ctrlKey && e.keyCode === 73) {
          return _this.toggleHandler();
        } else if (_this.isOpen()) {
          if (e.keyCode === 38) {
            if (_activeItemIndex() > 0) {
              _activeItemIndex(_activeItemIndex() - 1);
            }
            return false;
          } else if (e.keyCode === 40) {
            if (_activeItemIndex() < _this.displayOrgs().length - 1) {
              _activeItemIndex(_activeItemIndex() + 1);
            }
            return false;
          } else if (e.keyCode === 27) {
            _close();
            return false;
          } else if (e.keyCode === 13) {
            e.preventDefault();
            activeAccount = _this.activeItem();
            if (activeAccount) {
              _this.impersonateOrg(activeAccount);
            }
            return false;
          }
        }
      };
    })(this));
  }

  return AccountSwitcherViewModel;

})();
